import {ReactNode, useContext} from "react";
import {AuthContext} from "./AuthContext";
import React from "react";
import Login from "../../pages/Login";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const Authenticated: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {currentUser, loading} = useContext(AuthContext);
  if (loading) {
    return <Box>
      <CircularProgress/>
    </Box>;
  } else if (currentUser) {
    return <>{children}</>;
  } else {
    return <><Login/></>;
  }
}